import React from "react";
import { Bookmark, Pin, Teams, Verified } from "../../assets/icons";
import { EmployerBackground, Job } from "../../assets/images";

import "./VerifiedEmployer.scss";

interface Props {
  employer: {
    id: string;
    company_name: string;
    company_size: string;
    industries: [
      {
        id: number;
        industry: string;
      },
    ];
    number_of_employees: string;
    images: {
      banner_image: string;
      profile_image: string;
    };
    location: string;
  };
}

const VerifiedEmployer = ({ employer }: Props) => {
  return (
    <div className="verifiedEmployer">
      <div className="verifiedEmployer__bookmark">
        <Bookmark />
      </div>
      <img
        className="profile"
        src={employer.images?.profile_image}
        alt=""
        width="40px"
        height="40px"
      />
      <div
        className="image"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.30), rgba(0, 0, 0, 0.30)), url(${
            employer.images?.banner_image ?? EmployerBackground
          })`,
        }}
      ></div>
      <div className="verifiedEmployer__content">
        <div className="name">
          <div className="company-name">{employer.company_name}</div>
          <div className="verification">
            <Verified /> <span>Tribaja Verified</span>
          </div>
        </div>
        <div className="tags">
          {employer.industries.map((ind) => ind.industry).join(" • ")}
        </div>
        <div className="details">
          <span>
            <Pin /> {employer.location}
          </span>
          <span>
            <Teams /> {employer.number_of_employees} Employees
          </span>
        </div>
        <div className="buttons">
          <button
            className="invert"
            onClick={() =>
              window.open(
                `${process.env.REACT_APP_MAIN_URL}/profile/employer/${employer.id}`,
                "_blank"
              )
            }
          >
            View Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifiedEmployer;